import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { ReservationMeter, BalanceChip } from "@/components/boat-club/BoatClubVisuals";

/**
 * Home-page teaser block for Boat Clubs. Placed between the "Built by operators"
 * section and the Trust Strip. Visually bold without being louder than the hero —
 * uses the same section cadence as the rest of Home.jsx.
 */
export default function BoatClubTeaser() {
  return (
    <section className="ra-section bg-ra-paper border-y border-ra-line" data-testid="home-boat-club-teaser">
      <div className="ra-container">
        <div className="grid gap-12 lg:grid-cols-[1.05fr_1fr] lg:items-center">
          <div className="reveal">
            <div className="inline-flex items-center gap-2">
              <span
                className="inline-flex items-center gap-1 rounded-full bg-ra-coral/15 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-ra-coral"
                data-testid="home-boat-club-new-pill"
              >
                <Sparkles size={10} /> New
              </span>
              <span className="ra-eyebrow">For boat clubs</span>
            </div>

            <h2 className="mt-4 ra-h2" data-testid="home-boat-club-headline">
              Run your boat club on the same platform as your rentals.
            </h2>
            <p className="mt-5 ra-lead max-w-xl">
              Clubs sell access, not single rentals. Define your plans — reservation limits, peak limits, which boats, which days, hours or points — and every member booking is checked automatically. No more spreadsheet policing at the front desk.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/boat-club"
                className="ra-btn-primary"
                data-testid="home-boat-club-learn-more-btn"
              >
                Learn more <ArrowRight size={16} />
              </Link>
              <Link
                to="/contact?vertical=boat_club"
                className="ra-btn-ghost"
                data-testid="home-boat-club-demo-btn"
              >
                Book a Demo
              </Link>
            </div>
          </div>

          <div className="reveal">
            <div className="relative">
              {/* soft brand mesh behind the mocks */}
              <div
                className="absolute -inset-6 rounded-[2rem] pointer-events-none"
                aria-hidden="true"
                style={{
                  background:
                    "radial-gradient(55% 55% at 20% 20%, rgba(130,180,195,0.22) 0%, rgba(130,180,195,0) 70%), radial-gradient(45% 45% at 90% 90%, rgba(245,158,11,0.10) 0%, rgba(245,158,11,0) 70%)",
                }}
              />
              <div className="relative grid gap-4">
                <ReservationMeter used={3} total={4} peakUsed={2} peakTotal={2} />
                <div className="flex justify-end">
                  <BalanceChip value={21} unit="HRS" label="Remaining this season" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
